export default __webpack_public_path__ + "static/media/flat-rate-cash-back.a7bb9056.svg";